import { BaseModel } from './base-model'

export type UserType = 'Student' | 'Teacher'

export class User extends BaseModel {
  public id: number
  public type: UserType
  public loginId: string
  public name: string

  public get isStudent(): boolean {
    return this.type === 'Student'
  }

  public get isTeacher(): boolean {
    return this.type === 'Teacher'
  }
}



// WEBPACK FOOTER //
// ./src/models/user.ts